import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

import { environment } from "../../../../environments/environment";

@Component({
  selector: 'app-floating-buttons',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-buttons.component.html',
  styleUrls: ['./floating-buttons.component.scss']
})
export class FloatingButtonsComponent implements OnInit {
  isScrolled = false;

  ngOnInit() {
    // Inicialización si es necesaria
  }

  // Listener para detectar scroll
  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    // Mostrar botones flotantes solo en móvil cuando el usuario haga scroll hacia abajo
    this.isScrolled = window.scrollY > 100 && window.innerWidth <= 768;
  }

  // Listener para detectar cambios de tamaño de ventana
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    // Ocultar botones si se cambia a desktop
    if (window.innerWidth > 768) {
      this.isScrolled = false;
    }
  }

  // Método para abrir auto-apertura
  openAutoApertura(): void {
    window.open('https://www.unipay.cl/autoatencion-ptoventa/validar-identidad', '_blank', 'noopener,noreferrer');
  }

  // Método para abrir pago de estado de cuenta
  openPagoEstadoCuenta(): void {
    console.log("pagar estado de cuenta");
    window.open(environment.urlBase+'/pago', '_blank', 'noopener,noreferrer');
  }
}
